<template>
  <div :class="textColor" class="flex items-center justify-end gap-1">
    <span>{{ formattedValue }}</span>
    <div v-if="showIcon">
      <IconArrowDropUp
        v-if="isNumber"
        class="flex-shrink-0"
        :class="[textColor, isPositive ? 'rotate-180' : '']"
      />
      <div v-else :class="minusIconClasses" />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconArrowDropUp from '~/assets/icons/arrow-drop-up.svg'

const props = withDefaults(
  defineProps<{
    value?: number | null
    showIcon?: boolean
  }>(),
  {
    value: null,
    showIcon: true,
  },
)

const minusIconClasses = 'mx-[7px] h-[2px] w-[10px] rounded-full bg-black'

const formattedValue = computed(() => {
  if (props.value === null) return '--'
  return `${props.value}%`
})
const isNumber = computed(() => {
  return !!Number(props.value)
})
const isPositive = computed(() => {
  return isNumber.value && Number(props.value) >= 0
})
const textColor = computed(() => {
  if (!Number(props.value)) return 'text-black'
  if (isPositive.value) return 'text-upTableIndicator'
  return 'text-downTableIndicator'
})
</script>
